<template>
  <div>
    <input type="file" id="file" ref="file" @change="handleFileUpload()" hidden>
    <button class="btn w-280px" @click="chooseFiles">上傳檔案</button>
    {{ file }}
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    dir: {
      type: String,
      default: '',
    },
    format: {
      type: [Array, String],
      default: () => [
        'text/css',
      ],
    },
  },
  data: () => ({
    isMatch: true,
  }),
  computed: {
    file() {
      if (this.value && this.value.indexOf('/storage/') === 0) {
        return `${process.env.VUE_APP_HOST}${this.value}`;
      }

      return this.value;
    },
  },
  methods: {
    ...mapActions({
      upload: 'upload',
    }),
    ...mapActions('notifications', {
      error: 'error',
    }),
    handleFileUpload() {
      const formData = new FormData();
      const file = this.$refs.file.files[0];
      // if (this.format.indexOf(file.type) === -1) {
      //   return;
      // }
      if (file.type.indexOf('css') === -1) {
        this.error('支援格式：.css');
        return;
      }
      formData.append('file', file);
      formData.append('dir', this.dir);
      this.upload(formData).then((res) => {
        this.$emit('input', res.url);
      });
    },
    chooseFiles() {
      this.$refs.file.click();
    },
  },
};
</script>
<style lang="scss"></style>
